module.exports = __webpack_public_path__ + "media/images/kvimg_2sp-d0b128452ba632dfb2bae8fe4ac5bc40.jpg";